import {
  Avatar,
  Dropdown,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  Navbar,
  NavbarBrand,
  NavbarCollapse,
  NavbarLink,
  NavbarToggle,
} from "flowbite-react";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import { logoutUser } from "../store/slice/authThunks";
import { useNavigate } from "react-router-dom";
import React from "react";

const Navigation: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { token, user } = useSelector((state: RootState) => state.auth);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/login");
  };

  const handleDashboardClick = () => {
    if (user?.roles?.includes("ROLE_ADMIN")) {
      navigate("/dashboard/admin");
    } else if (user?.roles?.includes("ROLE_WORKMAN")) {
      navigate("/dashboard/handyman");
    } else {
      navigate("/dashboard/customer");
    }
  };

  return (
    <Navbar fluid rounded>
      <NavbarBrand href="/">
        <img src="/logo.png" className="h-10 w-auto" alt="Workman Naija Logo" />

        <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
          Workman Naija
        </span>
      </NavbarBrand>
      <div className="flex md:order-2">
        {token ? (
          <Dropdown
            arrowIcon={false}
            inline
            label={
              <Avatar
                alt="User settings"
                img="https://flowbite.com/docs/images/people/profile-picture-5.jpg"
                rounded
              />
            }
          >
            <DropdownHeader>
              <span className="block text-sm">
                {user?.email || "My Account"}
              </span>
              {user?.phone && (
                <span className="block truncate text-sm font-medium">
                  {user.phone}
                </span>
              )}
            </DropdownHeader>
            <DropdownItem onClick={handleDashboardClick}>Dashboard</DropdownItem>
            <DropdownDivider />
            <DropdownItem onClick={handleLogout}>Sign out</DropdownItem>
          </Dropdown>
        ) : null}
        <NavbarToggle />
      </div>
      <NavbarCollapse>
        <NavbarLink href="/" active>
          Home
        </NavbarLink>

        <NavbarLink href="/how-it-works">How it Works</NavbarLink>

        <NavbarLink href="/search">Find a Handyman</NavbarLink>

        <NavbarLink href="/register-provider">List Your Business</NavbarLink>

        <NavbarLink href="/download-app">Download App</NavbarLink>
        {!token && (
          <>
            <NavbarLink href="/userSignUp">Signup</NavbarLink>
            <NavbarLink href="/login">Login</NavbarLink>
          </>
        )}
      </NavbarCollapse>
    </Navbar>
  );
};

export default Navigation;
